import React from "react";
import Login from "./Login";
import {connect} from "react-redux";

class HeaderLoginContainer extends React.Component {
    render() {
        return (
            <>
                <li className="dropdown order-1">
                    <Login profile={this.props.profile} isLogin={this.props.isLogin}/>
                </li>
            </>
        )
    }

};
let mapStateToProps = (state) => {
    return {
        profile: state.profilePage,
        isLogin: state.profilePage.isLogin
    }
}
export default connect(mapStateToProps, null
)(HeaderLoginContainer);